/*
  Card-set cart controls — a merged "set" row in the cart represents two
  technical deck line items (see snippets/cart-line-items.liquid). The row's
  quantity and remove controls must update BOTH lines at once.
  Loaded globally; uses event delegation so it keeps working after the cart
  drawer re-renders its HTML.
*/
(function () {
  var busy = false;

  function refreshCart() {
    var cartPage = document.querySelector('cart-element[data-cart-page]');
    if (cartPage) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-element[data-cart-drawer]');
    if (drawer && typeof drawer.getCart === 'function') {
      drawer.getCart();
    } else {
      window.location.reload();
    }
  }

  function updatePair(keys, qty) {
    if (busy) return;
    busy = true;
    var updates = {};
    updates[keys[0]] = qty;
    updates[keys[1]] = qty;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); })
      .catch(function () { window.location.reload(); })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-set-remove]');
    if (removeBtn) {
      e.preventDefault();
      updatePair(removeBtn.getAttribute('data-set-keys').split('||'), 0);
      return;
    }

    var qtyBtn = e.target.closest('[data-set-qty-plus], [data-set-qty-minus]');
    if (!qtyBtn) return;
    e.preventDefault();

    var row = qtyBtn.closest('[data-set-row]');
    if (!row) return;
    var keys = row.getAttribute('data-set-keys').split('||');
    var field = row.querySelector('[data-set-qty-value]');
    var current = parseInt(field && field.value, 10) || 1;
    var max = parseInt(row.getAttribute('data-set-max'), 10);
    var qty = qtyBtn.hasAttribute('data-set-qty-plus') ? current + 1 : current - 1;

    if (qty < 0) qty = 0;
    if (!isNaN(max) && max > 0 && qty > max) qty = max;
    if (qty === current) return;

    updatePair(keys, qty);
  });
})();
